import React, { useRef, useState } from 'react'
import useInvoice from '../../hooks/useInvoice';
import useUser from '../../hooks/useUser';

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { LinearProgress } from '@mui/material';


import{    
    XCircleIcon,
    QuestionMarkCircleIcon,
    CreditCardIcon,
}from "@heroicons/react/24/outline"


function Invoice({status}) {
    
    console.log("Invoice->status", status);
    const { user } = useUser();
    const {invoices} = useInvoice(user?.customer_code, 2020, status, user?.token);
    console.log("Invoice->invoices", invoices);


    //Table
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,   
          height:60       
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',           
          height:50,
          padding:5,
          margin:0  
        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF',            
          },        
          [`&.${tableCellClasses.hover}`]: {            
            backgroundColor: "#0F0",
          },        
      }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,   
                     
        },       
        //hide last border
        // "&:last-child td, &:last-child th": {
        //     border: 0,
        // },
    }));
    
    // function convertUTCDateToLocalDate(date) {
    //     var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);    
    //     var offset = date.getTimezoneOffset() / 60;
    //     var hours = date.getHours();    
    //     newDate.setHours(hours - offset);    
    //     return newDate;   
    // }

    //credit card opoup
    var firstNamRef = useRef(null);
    const closeCreditCard = ()=>setopenCreditCard(false)
    const [openCreditCard, setopenCreditCard] = useState(false);
    const [invcTotal, setInvcTotal] = useState(0.00);
    const [invcNbr, setInvcNbr] = useState(0);
    

    function showCreditCard(e, invc_nbr, total)
    {
        setInvcNbr(invc_nbr);
        setInvcTotal(total);
        setopenCreditCard(true)
    }

  return (
    <div className="flex-grow overflow-y-auto bg-white">

        <div className='flex pl-10 pt-5 items-center space-x-3'>
            <div className='text-3xl font-bold' >{status == 0?"Paid Invoice":"Unpaid Invoice"}s:</div>
            <div className='p-1 text-center text-sm rounded-full bg-orange-600 text-white'>{invoices?.invoices?.length}</div>
        </div>   
        <div className='pl-10 pt-1 pr-10'>
            {!invoices &&
                <LinearProgress color='primary' />
            }
        </div>     
        <div className='pl-10 pt-1 pr-10'>   

            <TableContainer component={Paper}>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="30%" />
                    {status == 1 &&                    
                        <col width="20%" />
                    }
                    {status == 1 &&                    
                        <col width="30%" />
                    }
                    {status == 0 &&                    
                        <col width="10%" />
                    }                                                           
                </colgroup>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center">Invoice #</StyledTableCell>
                        <StyledTableCell align="center">Invoice Date</StyledTableCell>
                        {status == 1 &&                    
                            <StyledTableCell align="center">Due Date</StyledTableCell>
                        }
                        <StyledTableCell align="right">Amount</StyledTableCell>                        
                        {status == 1 &&                    
                            <StyledTableCell align="center">Pay Online</StyledTableCell>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                        {invoices?.invoices?.map((invc) => (              
                            <StyledTableRow key={`${invc.invc_nbr}`}>                                
                                <StyledTableCell align="center">
                                    <div className="text-gray-600 text-center" >{invc.invc_nbr}</div>                                    
                                </StyledTableCell>                            
                                                                    
                                <StyledTableCell align="center">
                                    {invc.invc_date !== "" &&
                                        <div className="text-gray-600 text-sm">                                
                                            {
                                            new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "long",
                                                day: "2-digit",                                                
                                            }).format(new Date(invc.invc_date))
                                            }                                                                
                                        </div>
                                    }
                                </StyledTableCell>    

                                {status == 1 &&   
                                    <StyledTableCell align="center">
                                        {invc.invc_date !== "" &&
                                        <div className="text-gray-600 text-sm">                                
                                            {
                                            new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "long",
                                                day: "2-digit",                                                
                                            }).format(new Date(invc.due_date))
                                            }                                                                
                                        </div>
                                    }
                                    </StyledTableCell>    
                                }
                                <StyledTableCell align="right"><div className="text-sm text-gray-500 text-right">${invc.total}</div></StyledTableCell>                                       
                                    {status == 1 &&   
                                    <StyledTableCell align="center">
                                    <div className='flex justify-evenly text-orange-500 cursor-pointer'>
                                        <CreditCardIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>showCreditCard(e, invc.invc_nbr, invc.total)} />                                        
                                    </div>
                                </StyledTableCell>                     
                                }                                
                            </StyledTableRow>
                        ))}                          
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        {openCreditCard &&
            <div className='popupContainer overflow-auto scroll-auto '>                        
            <div className='w-1/4 h-96 bg-white rounded-lg shadow-2xl border-t-2 border-orange-700'>
                <div className='relative flex items-center p-3 justify-evenly border-b'>
                    <div className=' text-black font-semibold font-sans'>
                        Pay Onlne
                    </div>                    
                    <div className=' absolute text-gray-300 top-1 right-1 cursor-pointer'>
                        <XCircleIcon className='h-9 w-9 text-red-600' onClick={closeCreditCard}></XCircleIcon>                    
                    </div> 
                </div>  
                <div className='mx-5 mt-2'>
                    <div className='flex justify-between'>
                        <div className='flex  items-center space-x-2'>
                            <div className='font-semibold'> Invoice Total: </div>
                            <div className='text-gray-600'> {invcTotal} </div>
                        </div>
                        <div className='flex  items-center space-x-2'>
                            <div className='font-semibold'> Invoice #: </div>
                            <div className='text-gray-600'> {invcNbr} </div>
                        </div>                                                
                    </div>
                    

                    <div className='flex justify-between mt-3 text-gray-500 font-semibold'>
                        <p>Card number</p>
                        <img src="/creditcard.jpg" width ={120}  height={20} layout ='fixed' />
                    </div>
                    <div className='flex flex-grow space-x-3'>
                        <input ref={firstNamRef} className='border-gray-200 border  rounded-lg bg-tran flex-grow h-10 px-6 focus:outline-none'                         
                        type='text'                         
                        placeholder="1234 5678 9012 1314"
                        />
                    </div> 

                    <div className='mt-3 text-gray-500 font-semibold'>Name on card</div>
                    <div className='flex flex-grow space-x-3'>
                        <input ref={firstNamRef} className='border-gray-200 border  rounded-lg bg-tran flex-grow h-10 px-6 focus:outline-none'                         
                        type='text'                         
                        placeholder="Ex. Elon Musk"
                        />                        
                    </div> 
                    <div className='flex mt-3 items-center'>
                        <div className='items-center w-1/3'>
                            <div className='text-gray-500 font-semibold'>Expiry date</div>
                            <div className=''>
                                <input ref={firstNamRef} className='border-gray-200 border  rounded-lg bg-tran h-10 w-20 px-6 focus:outline-none'                                 
                                type='text'                         
                                placeholder="01/20"
                                />                        
                            </div> 
                        </div>                        
                        <div className='items-center w-1/3'>
                            <div className='text-gray-500 font-semibold'>Security code</div>
                            <div className=''>
                                <input ref={firstNamRef} className='border-gray-200 border  rounded-lg bg-tran h-10 px-6 w-48 focus:outline-none'                                 
                                type='text'                         
                                placeholder="* * *"
                                />                        
                            </div> 
                        </div> 
                        <div className='items-center w-1/3'>
                            <QuestionMarkCircleIcon className='h-8 w-8 mt-6 text-gray-300 cursor-pointer hover:text-gray-600' />
                        </div>                        
                    </div>
                    <div className='bg-orange-400 text-white font-semibold text-center mt-5 p-2 rounded-lg cursor-pointer hover:bg-orange-500'>Next</div>
                </div>
            </div>  
        </div>
        }
    </div>
  )
}

export default Invoice